import { render } from "./PriorityMatrixTable.vue?vue&type=template&id=528bd982"
import script from "./PriorityMatrixTable.vue?vue&type=script&lang=js"
export * from "./PriorityMatrixTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__